import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";

const Home                = lazy(() => import("./pages/Home"));
const Privacy             = lazy(() => import("./pages/Privacy"));
const Terms               = lazy(() => import("./pages/Terms"));
const Cookies             = lazy(() => import("./pages/Cookies"));
const NotFound            = lazy(() => import("./pages/NotFound"));

const LoadingFallback = () => (
  <div style={{
    background: 'var(--paper)',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{
      width: '32px',
      height: '32px',
      border: '2px solid var(--hair)',
      borderTopColor: 'var(--rust)',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingFallback />}>
        <BrowserRouter>
          <Routes>
            <Route path="/"        element={<Home />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms"   element={<Terms />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="*"        element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}

export default App;
